import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { BaseUrl as getBlobBaseUrl } from '../../utility/BaseUrl'
import { AppContext } from '../../App'
import { AppDataList } from '../home/HomePage'
import { isValidJson } from '../../utility/Utility'
import { AppTitle, AppDescription, IconWrapper } from '../../css/Style'

interface IProps{
  isSearch : boolean;
  apps: AppDataList[] | undefined
}

interface HiddenProps {
  hide: boolean;
}

const RelatedApp = styled.div`
  padding-bottom: 20px;
`

const PopularAppsHeading = styled.div`
  font-family: 'AeonikPro-Medium';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #35324A;
  margin: 46px 0px 20px 0px;
  @media only screen and (max-width: 420px) {
      margin: 36px 0px 20px 0px;
      font-size: 24px;
      line-height: 36px;
  }
  @media (min-width: 421px) and (max-width: 900px){
    margin: 10px 0px 20px 0px;
    font-size: 24px;
    line-height: 36px;
}
`

const Gallery = styled.div`
  height: fit-content;
  width: 100%;
  overflow: hidden;
  margin: 32px 0px;
  display: flex;
  flex-direction: row;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 5px 0px;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 0px) and (max-width: 420px) {
         flex-direction: column;
         max-height: 600px;
         margin: 0px;
          overflow-x: hidden;
              -ms-overflow-style-x: hidden;
         overflow-y: none;
         -ms-overflow-style-y: none;
  }
`

const PopularAppsGallery = styled(Gallery)`
     margin: 0;
     @media (min-width: 0px) and (max-width: 360px) {
              flex-direction: column;
              margin-right: 0px;
              overflow-x: hidden;
              -ms-overflow-style-x: hidden;
     }
 `

const PopularApp = styled.div<HiddenProps>`
 
    width:${(props) => props.hide ? '285px' : '386.67px'};
    height: ${(props) => props.hide ? '240px' : '252px'} ;
    position: relative;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1.2px solid #DCDFEC;
    border-radius: 8px;
    padding: 16px;
    margin-right: 20px;
    cursor: pointer;

    /* Auto layout */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: none;
    &:hover  {
      box-shadow: 0px 8px 12px rgba(115, 115, 115, 0.25);
    };

    @media only screen and (max-width: 420px) {
         width:100%;
         height:276px;
         margin-bottom: 16px;
    }

`

const PopularAppIcon = styled.img`
    width:48px;
    height:48px;
    box-sizing: border-box;
    margin-bottom: 16px;
    cursor: pointer;
`

const PopularAppTitle = styled(AppTitle)`
    box-sizing: border-box;
    min-height: 50px;
    margin-bottom: 8px;
    padding-top: 8px;
    padding-bottom : 8px;
`

const PopularAppEmployeeOnBoarding = styled.div`
  color: #EA5834;
  position: absolute;
  bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  white-space: nowrap;
  padding-bottom: 17.5px;
  font-size: 12px;
  font-family: 'AeonikPro-Medium';
`

const RelatedApps = (props: IProps) => {
  const { isSearch } = props
  const { apps } = props
  const [popularApps] = useState(apps)
  const navigate = useNavigate()
  const { setCurrentApp } = useContext(AppContext)

  function routeToDetail (id: string) {
    setCurrentApp(id)
    navigate('/details/' + id)
  }

  const getAppIcon = (icon: string) => {
    if (icon) {
      icon = icon && isValidJson(icon) ? JSON.parse(icon).path : icon
      return <IconWrapper src= {`https://${getBlobBaseUrl()}${icon}`} />
    }
  }

  return (
    <RelatedApp>
        <PopularAppsHeading> Recommended </PopularAppsHeading>
        <PopularAppsGallery>
          {popularApps && popularApps.map((app, index) => (<PopularApp hide = {isSearch} key = {'pa_' + index} onClick={() => { routeToDetail(app.appId) }}>
                                                 {app.icon && getAppIcon(app.icon)}
                                                 {!app.icon && <PopularAppIcon src={app.icon}/>}
                                                 <PopularAppTitle>{app.name}</PopularAppTitle>
                                                 <AppDescription>
                                                    {app.description}
                                                </AppDescription>
                                                 <PopularAppEmployeeOnBoarding>{app.useCaseList && app.useCaseList.length > 0 ? app.useCaseList.join(', ') : ''}</PopularAppEmployeeOnBoarding>
                                            </PopularApp>))}
        </PopularAppsGallery>
      </RelatedApp>
  )
}

export default RelatedApps
